import { render } from "./ScheduleService.vue?vue&type=template&id=2a53f4f0&lang=true"
import script from "./ScheduleService.vue?vue&type=script&lang=js"
export * from "./ScheduleService.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/StartUpIcons/ScheduleService.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a53f4f0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a53f4f0', __exports__)) {
    api.reload('2a53f4f0', __exports__)
  }
  
  module.hot.accept("./ScheduleService.vue?vue&type=template&id=2a53f4f0&lang=true", () => {
    api.rerender('2a53f4f0', render)
  })

}


export default __exports__